document.addEventListener('DOMContentLoaded', () => {
	const section = document.querySelector('.tabbed-cards')
	const tabContentContainer = section.querySelector('.tab-content-container')
	const tabs = section.querySelectorAll('.tab-content')
	const tabSelectors = section.querySelector('.tab-selectors')
	const titles = section.querySelectorAll('.title')

	//init
	let currentTab = 0;
	let underlineTranslatePercentage = 0;
	let underlineWidth = 100 / titles.length;

	function activateTab(index) {
		currentTab = index;
		titles.forEach((t, i) => {
			t.classList.remove('active')
			t.setAttribute('aria-selected', i === index ? 'true' : 'false')
			t.setAttribute('tabindex', i === index ? '0' : '-1')
		})
		tabs.forEach(t => t.classList.remove('active'))
		updateUnderline();

		// Measure the incoming tab's height before it's hidden so the container can transition smoothly
		tabs[index].classList.remove('hidden')
		const nextHeight = tabs[index].scrollHeight
		tabContentContainer.style.setProperty('--height', nextHeight + 'px')

		setTimeout(() => {
			tabs.forEach(t => t.classList.add('hidden'))
			titles[index].classList.add('active')
			tabs[index].classList.remove('hidden')
			tabs[index].classList.add('active')
		}, 500)
	}

	function checkHash() {
		const hash = window.location.hash.substring(1); // Remove the #
		let tabFound = false;

		titles.forEach((title, index) => {
			const buttonId = title.getAttribute('id');

			if (hash === buttonId) {
				activateTab(index);
				tabFound = true;
			}
		});

		if (!tabFound) {
			titles[0].classList.add('active')
			titles[0].setAttribute('aria-selected', 'true')
			titles[0].setAttribute('tabindex', '0')
			for (let i = 1; i < titles.length; i++) {
				titles[i].setAttribute('aria-selected', 'false')
				titles[i].setAttribute('tabindex', '-1')
			}
			tabs[0].classList.add('active')
			updateHeight()
			updateUnderline()
		}
	}

	// Check hash on initial load
	checkHash();

	titles.forEach((title, index) => {
		title.addEventListener('click', e => {
			activateTab(index);
		})
	})

	tabSelectors.addEventListener('keydown', e => {
		let newIndex = currentTab
		if (e.key === 'ArrowRight') newIndex = (currentTab + 1) % titles.length
		else if (e.key === 'ArrowLeft') newIndex = (currentTab - 1 + titles.length) % titles.length
		else if (e.key === 'Home') newIndex = 0
		else if (e.key === 'End') newIndex = titles.length - 1
		else return
		e.preventDefault()
		activateTab(newIndex)
		titles[newIndex].focus()
	})

	// Listen for hash changes
	window.addEventListener('hashchange', () => {
		checkHash();
	})

	function updateUnderline() {
		underlineTranslatePercentage = 100 * currentTab;
		tabSelectors.style.setProperty('--underline-translate', underlineTranslatePercentage + '%')
		tabSelectors.style.setProperty('--underline-width', underlineWidth + '%')
	}

	function updateHeight() {
		tabContentContainer.style.setProperty('--height', tabs[currentTab].scrollHeight + 'px')
	}


	window.addEventListener('resize', () => {
		updateHeight();
	})


})
